import { client, gql } from 'data-provider';
import { IAddress, IClient } from 'interfaces';

interface GetAllClientParam {
  searchString?: string;
  start?: number;
  limit?: number;
}

export const getAllClient = async (queryParam?: GetAllClientParam) => {
  const where = { query: '' };
  if (queryParam?.searchString) {
    where.query = queryParam.searchString;
  }

  const clientQuery = gql`
    query ($where: JSON, $sort: SortInput, $start: Int, $limit: Int) {
      clients(where: $where, sort: $sort, start: $start, limit: $limit) {
        data {
          id
          name
          email
          clientCode
          mobileNumber
          clientPhoto {
            avatar {
              url
              thumbUrl
            }
          }
          address {
            id
            street
            area
            city
            country
            zip
          }
          clientTags {
            tag {
              id
              name
              description
            }
          }
        }
        total
        size
        page
      }
    }
  `;

  const variables = {
    where,
    start: queryParam && queryParam.start ? queryParam.start : 1,
    limit: queryParam && queryParam.limit ? queryParam.limit : 10,
  };
  const data = await client.request(clientQuery, variables);
  return data.clients as {
    data: IClient[];
    page: number;
    size: number;
    total: number;
  };
};

export const getClient = async (clientId: string) => {
  const query = `
    query($id: ID!) {
      client(id: $id) {
        id
        name
        email
        clientCode
        mobileNumber
        clientPhoto {
          avatar {
            url
            thumbUrl
          }
        }
        address {
          id
          street
          area
          city
          country
          zip
        }
        pointOfContacts {
          id
          name
        }
      }
    }
  `;

  const variables = { id: clientId };
  const data = await client.request(query, variables);
  return data.client as IClient;
};

export interface IClientFile {
  name: string;
  clientCode: string;
  email?: string;
  mobileNumber?: string;
  address?: Partial<Omit<IAddress, 'id'>>;
}

export const importClient = async (suppliers: IClientFile[]) => {
  const importSupplier = `
    mutation ($input: createInputCSVBulkClientInput) {
      importCSVClient(input: $input) {
        id
      }
    }
  `;

  const variables = {
    input: { data: suppliers },
  };
  const createdData = await client.request(importSupplier, variables);
  return createdData;
};

export const getClientsDropdown = async () => {
  const query = gql`
    query {
      clientDropdown {
        id
        name
        email
        mobileNumber
        clientCode
      }
    }
  `;

  const data = await client.request(query);
  return data.clientDropdown as Omit<
    IClient,
    'address' | 'pointOfContacts' | 'clientPhoto' | 'clientTags' | 'payMethods'
  >[];
};

export const getClientsExport = async () => {
  const query = gql`
    query {
      clientDropdown {
        id
        name
        email
        mobileNumber
        clientCode
        address {
          id
          street
          area
          city
          country
          zip
        }
        clientTags {
          id
          tag {
            name
          }
        }
      }
    }
  `;

  const data = await client.request(query);
  return data.clientDropdown as IClient[];
};
